<script setup>
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'
import vTextareaAutoGrow from '@/vue/directives/textareaAutoGrow'
import vFormValidation from '@/vue/directives/formValidation'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
})

const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

const formSmall = computed(() => formStore.value?.formSmall)
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <textarea v-else :id="field.id" ref="field" v-model="currentData[field.name]" v-form-validation v-textarea-auto-grow
              :cols="field.cols" :disabled="field.disabled" :minlength="field.minlength" :name="field.name"
              :placeholder="field.placeholder || undefined" :required="field.required" :rows="field.rows" :wrap="field.wrap"
              class="form-control" :class="{'is-invalid': field.error, 'form-control-sm': formSmall}"/>
</template>